<div class="h-100 d-flex flex-column align-items-center align-items-sm-start">
  <div class="d-flex d-sm-none justify-content-end w-100 pt-3 pe-3">
    <i
      class="pointer font-size-lg fa-solid fa-circle-xmark"
      (click)="closeSidebar()"
    ></i>
  </div>
  <div
    class="d-flex flex-nowrap align-items-center justify-content-center justify-content-sm-start gap-2 pt-3 px-3 w-auto"
  >
    <base-avatar
      [image]="userData.avatar?.data"
      [size]="avatarSizes.medium"
      class="mx-2"
    ></base-avatar>
    <div class="d-flex flex-column align-items-start">
      <span class="fw-bold">{{ userFullName }}</span>
      <span>{{ userData.position }}</span>
    </div>
  </div>
  <hr />
  <div class="d-flex align-items-center gap-2 px-3">
    <base-avatar
      [image]="companyData.logo?.data"
      [size]="avatarSizes.medium"
      [isCompany]="true"
    ></base-avatar>
    <span>{{ companyData.primaryData.name }}</span>
  </div>
  <hr />
  <ul
    class="user-nav-body list-unstyled mx-3 my-2"
    *ngFor="let item of userMenuItems"
  >
    <li
      class="text-uppercase bold-font"
      *ngIf="item.id !== 60 || (item.id === 60 && signDigital)"
    >
      <a
        class="text-decoration-none text-dark-blue outline-transparent hover-text-primary no-outline"
        [routerLink]="item.url"
      >
        {{ item.title | translate }}
      </a>
    </li>
  </ul>
  <div
    class="w-100 d-flex flex-column flex-column-reverse justify-content-around align-items-center gap-4 p-3 flex-sm-row justify-content-sm-between gap-sm-0"
  >
    <base-language-switch [isDisplayedInSidebar]="true"></base-language-switch>
    <a
      class="user-nav-logout fw-bold link-underline link-underline-opacity-0"
      routerLink="/auth/logout"
      (click)="closeSidebar()"
    >
      <span>{{ 'auth.logout' | translate }}</span>
      <i class="fa-solid fa-fw fa-chevron-right"></i>
    </a>
  </div>
</div>
